module.exports = __webpack_public_path__ + "static/p22-09fd0e5fc0a5fd93d93293b26f099017.jpg";